module.exports = __webpack_public_path__ + "static/img/solutionDetailPic10.82ef630.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic10.jpg
// module id = T2LU
// module chunks = 1